import { CartLinesUpdateEvent } from '@shopify/events';
import CSS from './bag-2x1-css.js';
const COLLECTION_URL = '/collections/borse/products.json?limit=250';
const MAX_BAGS = 250;
const ensureJs = (url, fb) => {
const b = url || fb;
return b.endsWith('.js') ? b : `${b}.js`;
};
const CART_ADD_URL = ensureJs(window.Theme?.routes?.cart_add_url, '/cart/add.js');
const CART_CHANGE_URL = ensureJs(window.Theme?.routes?.cart_change_url, '/cart/change.js');
const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
const fmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' });
const eur = (v) => fmt.format(Number(v));
const esc = (s) => {
const d = document.createElement('div');
d.textContent = s ?? '';
return d.innerHTML;
};
const track = (n) => {
try {
if (window.clarity) window.clarity('event', n);
} catch (e) {
/* noop */
}
};
const BARS = new Set();
const sized = (url, w) => {
if (!url) return '';
const sep = url.includes('?') ? '&' : '?';
return url + sep + 'width=' + w + (BARS.has(url) ? '&height=' + Math.round(w * 1.25) + '&crop=center' : '');
};
const SUB_W = 640;
const warmed = new Set();
const warmUrl = (u) => {
if (!u || warmed.has(u)) return;
warmed.add(u);
const im = new Image();
im.decoding = 'async';
im.src = u;
};
const warm = (p) => (p.images || []).forEach((i) => warmUrl(sized(i.src, SUB_W)));
const ensureStyle = () => {
if (document.getElementById('b21-css')) return;
const s = document.createElement('style');
s.id = 'b21-css';
s.textContent = CSS;
document.head.appendChild(s);
};
let catalogPromise = null;
const loadCatalog = () => {
if (!catalogPromise) {
catalogPromise = fetch(COLLECTION_URL)
.then((r) => (r.ok ? r.json() : Promise.reject(new Error('catalog'))))
.then((j) => {
const ps = j.products || [];
ps.forEach((p) => {
const t = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
if (t.some((x) => String(x).trim() === 'foto-barre') && p.images && p.images[0]) BARS.add(p.images[0].src);
});
return ps;
})
.catch((e) => {
catalogPromise = null;
throw e;
});
}
return catalogPromise;
};
const TEXTS = {
add: ['Scegli la tua borsa preferita', 'La seconda è gratis', true, 'Scegli questa · GRATIS'],
free: ['Cambia la borsa gratis', 'Scegli quella che preferisci: è gratis', true, 'Scegli questa · GRATIS'],
paid: ['Cambia la tua borsa', 'Scegli quella che preferisci', false, 'Scegli questa borsa'],
};
class BagPopup {
constructor(o) {
this.mode = o.mode;
this.btn = o.btn || null;
this.change = o.change || null;
this.exclude = (o.exclude || []).map(String);
this.current = o.current || null;
this.refPrice = o.refPrice;
this.busy = false;
ensureStyle();
this.build();
this.fill();
track(this.mode === 'add' ? 'b21_open' : 'b21_change_open');
}
build() {
const [h, sub, , ] = TEXTS[this.mode];
const c = this.current;
const slots =
this.mode === 'add' && c
? `<div class="b21-pop__slots">
<div class="b21-pop__slot"><img src="${esc(c.image)}" alt=""><div><b>La tua borsa</b><span>${esc(c.title)}</span></div></div>
<div class="b21-pop__slot b21-pop__slot--empty" data-b21-slot>+ La tua borsa<br>GRATIS</div>
</div>`
: '';
const pop = document.createElement('dialog');
pop.className = 'b21-pop';
pop.innerHTML = `
<div class="b21-pop__sheet" role="document" aria-labelledby="b21-title">
<div class="b21-pop__top">
<button type="button" class="b21-pop__x" aria-label="Chiudi">×</button>
<h3 class="b21-pop__h" id="b21-title">${h}</h3>
<p class="b21-pop__sub">${sub}</p>
${slots}
</div>
<div class="b21-pop__grid" data-b21-grid><p class="b21-pop__msg">Caricamento…</p></div>
<div class="b21-sub" data-b21-sub><div class="b21-sub__box" data-b21-subbox></div></div>
<div class="b21-pop__busy" data-b21-busy aria-live="polite"></div>
</div>`;
document.body.appendChild(pop);
document.documentElement.style.overflow = 'hidden';
this.pop = pop;
this.grid = pop.querySelector('[data-b21-grid]');
this.slot = pop.querySelector('[data-b21-slot]');
this.subEl = pop.querySelector('[data-b21-sub]');
this.subBox = pop.querySelector('[data-b21-subbox]');
this.busyEl = pop.querySelector('[data-b21-busy]');
pop.querySelector('.b21-pop__x').addEventListener('click', () => this.close());
pop.addEventListener('click', (e) => {
if (e.target === pop) this.close();
});
this.subEl.addEventListener('click', (e) => {
if (e.target === this.subEl) this.closeSub();
});
pop.addEventListener('cancel', (e) => e.preventDefault());
this.onKey = (e) => {
if (e.key !== 'Escape') return;
e.preventDefault();
e.stopImmediatePropagation();
if (this.subEl.classList.contains('is-on')) this.closeSub();
else this.close();
};
document.addEventListener('keydown', this.onKey, true);
try {
pop.showModal();
} catch (err) {
pop.setAttribute('open', '');
}
pop.querySelector('.b21-pop__x').focus();
}
close() {
if (this.busy) return;
document.removeEventListener('keydown', this.onKey, true);
document.documentElement.style.overflow = '';
try {
this.pop.close();
} catch (err) {
/* noop */
}
this.pop.remove();
BagPopup.active = null;
this.btn?.focus?.();
}
async fill() {
let products = [];
try {
products = await loadCatalog();
} catch (e) {
this.grid.innerHTML = '<p class="b21-pop__msg">Non riesco a caricare le borse. Riprova.</p>';
return;
}
const skip = new Set(this.exclude);
if (this.current) skip.add(String(this.current.productId));
const ref = this.refPrice ?? (this.current ? Number(this.current.price) : null);
const items = products
.filter((p) => !skip.has(String(p.id)))
.map((p) => ({ p, v: (p.variants || []).find((x) => x.available) }))
.filter((x) => x.v && x.p.images && x.p.images[0]);
const same = ref == null ? [] : items.filter((x) => Number(x.v.price) === Number(ref));
const rest = ref == null ? items : items.filter((x) => Number(x.v.price) !== Number(ref));
const list = [...same, ...rest].slice(0, MAX_BAGS);
if (!list.length) {
this.grid.innerHTML = '<p class="b21-pop__msg">Nessuna borsa disponibile al momento.</p>';
return;
}
const free = TEXTS[this.mode][2];
this.grid.innerHTML = '';
list.forEach(({ p, v }, i) => {
const card = document.createElement('button');
card.type = 'button';
card.className = 'b21-card';
const old = v.compare_at_price && Number(v.compare_at_price) > Number(v.price) ? `<s>${eur(v.compare_at_price)}</s>` : '';
const price = free ? '<b>GRATIS</b>' : `<b class="b21-card__price">${eur(v.price)}</b>`;
card.innerHTML = `<div class="b21-card__img"><img src="${esc(sized(p.images[0].src, 400))}" alt="" ${i < 6 ? '' : 'loading="lazy"'} width="400" height="400">${free ? '<span class="b21-card__tag">GRATIS</span>' : ''}</div><div class="b21-card__meta">${esc(p.title)}<br>${old}${price}</div>`;
card.addEventListener('click', () => this.openSub(p, v));
['pointerenter', 'pointerdown', 'touchstart'].forEach((ev) => card.addEventListener(ev, () => warm(p), { once: true, passive: true }));
this.grid.appendChild(card);
});
const queue = list.slice(0, 8).flatMap(({ p }) => (p.images || []).slice(0, 3).map((im) => sized(im.src, SUB_W)));
let k = 0;
const next = () => {
if (!this.pop.isConnected || k >= queue.length) return;
warmUrl(queue[k++]);
setTimeout(next, 100);
};
(window.requestIdleCallback || setTimeout)(next);
}
openSub(p, v) {
track('b21_view');
warm(p);
const imgs = (p.images || []).map((i) => i.src);
const thumbs =
imgs.length > 1
? `<div class="b21-sub__thumbs">${imgs
.map((u, k) => `<button type="button" class="b21-sub__th${k ? '' : ' is-on'}" data-k="${k}" aria-label="Foto ${k + 1}"><img src="${esc(sized(u, 120))}" alt="" decoding="async"></button>`)
.join('')}</div>`
: '';
this.subBox.innerHTML = `<button type="button" class="b21-sub__x" aria-label="Chiudi">×</button><div class="b21-sub__main"><img alt="${esc(p.title)}" decoding="async" fetchpriority="high"></div>${thumbs}<button type="button" class="b21-sub__ok">${TEXTS[this.mode][3]}</button>`;
const main = this.subBox.querySelector('.b21-sub__main img');
const show = (k) => {
const hi = sized(imgs[k], SUB_W);
main.dataset.u = hi;
if (k === 0 && !warmed.has(hi)) {
main.src = sized(imgs[0], 400);
warmUrl(hi);
const t = new Image();
t.onload = () => {
if (main.dataset.u === hi) main.src = hi;
};
t.src = hi;
} else {
main.src = hi;
}
};
show(0);
this.subBox.querySelectorAll('.b21-sub__th').forEach((t) =>
t.addEventListener('click', () => {
show(Number(t.dataset.k));
this.subBox.querySelectorAll('.b21-sub__th').forEach((x) => x.classList.toggle('is-on', x === t));
})
);
this.subBox.querySelector('.b21-sub__x').addEventListener('click', () => this.closeSub());
this.subBox.querySelector('.b21-sub__ok').addEventListener('click', () => this.pick(p, v));
this.subEl.classList.add('is-on');
this.subBox.querySelector('.b21-sub__ok').focus();
}
closeSub() {
this.subEl.classList.remove('is-on');
}
showBusy(html, err) {
this.busyEl.className = 'b21-pop__busy is-on' + (err ? ' is-err' : '');
this.busyEl.innerHTML = html;
}
async pick(p, v) {
if (this.busy) return;
this.busy = true;
track('b21_pick');
if (this.slot) {
this.slot.className = 'b21-pop__slot';
this.slot.innerHTML = `<img src="${esc(sized(p.images[0].src, 120))}" alt=""><div><b>GRATIS</b><span>${esc(p.title)}</span></div>`;
}
this.showBusy(this.mode === 'add' ? 'Aggiungo al carrello…<span>Il 2x1 si applica da solo</span>' : 'Aggiorno il carrello…<span>Il 2x1 si applica da solo</span>');
const flag = { _bundle2x1: 'yes' };
const items =
this.mode === 'add'
? [
{ id: Number(this.current.variantId), quantity: 1, properties: flag },
{ id: v.id, quantity: 1, properties: flag },
]
: [{ id: v.id, quantity: 1, properties: flag }];
const deferred = CartLinesUpdateEvent.createPromise();
document.dispatchEvent(
new CartLinesUpdateEvent({
action: 'add',
context: 'standard-action',
lines: items.map((i) => ({ merchandiseId: i.id, quantity: 1 })),
promise: deferred.promise,
})
);
let ok = false;
let removed = false;
try {
if (this.change) {
const rm = await fetch(CART_CHANGE_URL, {
method: 'POST',
headers: JSON_HEADERS,
body: JSON.stringify({ id: this.change.key, quantity: Math.max(0, (this.change.quantity || 1) - 1) }),
});
if (!rm.ok) throw new Error('remove');
removed = true;
}
const res = await fetch(CART_ADD_URL, {
method: 'POST',
headers: JSON_HEADERS,
body: JSON.stringify({ items, sections: 'cart-drawer-section' }),
});
const json = await res.json();
if (!res.ok || json.status) {
deferred.resolve({ detail: { source: 'bag-2x1', didError: true } });
} else {
ok = true;
deferred.resolve({
detail: { sections: json.sections, items: json.items, itemCount: json.item_count, source: 'bag-2x1', didError: false },
});
}
} catch (e) {
deferred.resolve({ detail: { source: 'bag-2x1', didError: true } });
}
if (!ok && removed && this.change) {
try {
await fetch(CART_ADD_URL, {
method: 'POST',
headers: JSON_HEADERS,
body: JSON.stringify({ items: [{ id: Number(this.change.variantId), quantity: 1, properties: flag }] }),
});
} catch (e) {
/* noop */
}
}
this.busy = false;
track(ok ? 'b21_added' : 'b21_error');
if (!ok) {
this.showBusy('Non disponibile, scegli un’altra borsa<span>Tocca per riprovare</span>', true);
this.closeSub();
this.busyEl.onclick = () => {
this.busyEl.className = 'b21-pop__busy';
this.busyEl.onclick = null;
};
return;
}
this.close();
if (location.pathname.startsWith('/cart')) {
location.reload();
return;
}
if (!document.querySelector('theme-drawer[open], cart-drawer-component dialog[open]')) {
const opener = document.querySelector('[aria-controls="cart-drawer"]');
if (opener) opener.click();
else window.location.href = '/cart';
}
}
}
const CHG = '.mf-2x1-chip__chg';
const CHIP_HTML =
'<span class="mf-2x1-chip__ok"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>2×1 applicato</span><a class="mf-2x1-chip__chg" href="/pages/2x1-accessori">Cambia</a>';
const getBags = async () => {
try {
const [cart, products] = await Promise.all([fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()), loadCatalog()]);
const ids = new Set(products.map((p) => String(p.id)));
return (cart.items || []).filter((i) => ids.has(String(i.product_id)));
} catch (e) {
return [];
}
};
let enhancing = false;
let timer = null;
const enhance = async () => {
if (enhancing) return;
const chips = document.querySelectorAll(`${CHG}:not([data-b21-chg])`);
if (!chips.length) return;
enhancing = true;
try {
const bags = await getBags();
chips.forEach((a) => (a.dataset.b21Chg = 'x'));
bags.forEach((it) => {
const key = it.key;
document.querySelectorAll(`tr[data-key="${key.replace(/"/g, '\\"')}"]`).forEach((row) => {
let a = row.querySelector(CHG);
if (!a) {
const wrap = row.querySelector('.cart-items__variants-wrapper');
if (!wrap) return;
const ul = document.createElement('ul');
ul.className = 'list-unstyled';
ul.setAttribute('role', 'list');
ul.innerHTML = `<li class="mf-2x1-chip">${CHIP_HTML}</li>`;
wrap.appendChild(ul);
a = ul.querySelector(CHG);
}
a.dataset.b21Chg = 'x';
});
});
} finally {
enhancing = false;
}
};
const schedule = () => {
clearTimeout(timer);
timer = setTimeout(enhance, 120);
};
if (!window.__b21Bound) {
window.__b21Bound = true;
document.addEventListener('click', async (e) => {
const open = e.target.closest?.('[data-b21-open]');
if (open) {
if (BagPopup.active) return;
e.preventDefault();
const d = open.dataset;
const formVariant = open.closest('form')?.querySelector('input[name="id"]')?.value;
BagPopup.active = new BagPopup({
mode: 'add',
btn: open,
current: {
productId: String(d.productId),
variantId: formVariant || d.variantId,
price: d.price,
title: d.title,
image: d.image,
},
});
return;
}
const chg = e.target.closest?.(CHG);
if (chg) {
e.preventDefault();
if (BagPopup.active) return;
const key = chg.closest('[data-key]')?.dataset.key;
const bags = await getBags();
const target = bags.find((i) => i.key === key);
if (!target) {
window.location.href = '/pages/2x1-accessori';
return;
}
if (BagPopup.active) return;
BagPopup.active = new BagPopup({
mode: target.total_discount > 0 ? 'free' : 'paid',
change: { key: target.key, variantId: target.variant_id, quantity: target.quantity },
exclude: bags.map((i) => i.product_id),
refPrice: (target.original_price ?? target.price) / 100,
});
}
});
const start = () => {
schedule();
if (window.MutationObserver) new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
else start();
}